import apiClient from "@/lib/axios";
import { User } from "@/features/auth/api/auth";

export type UpdateProfilePayload = {
    first_name?: string;
    last_name?: string;
    username?: string;
    phone_number?: string;
    gender?: string; // "male" | "female" | "other"
    country?: string;
    address_line_1?: string;
    address_line_2?: string;
    travel_preferences?: string;
    tour_style?: string;
    interests?: string[];
    dietary_restrictions?: string[];
    cuisine_preferences?: string[];
    avoid_foods?: string[];
    accessibility_needs?: string[];
};

export async function updateProfile(payload: UpdateProfilePayload) {
    const res = await apiClient.patch<User>("/api/v1/users/me", payload);
    return res.data;
}

export async function uploadPhoto(file: File) {
    const formData = new FormData();
    formData.append('photo', file);

    // The user specified /api/v1/users/me/photo
    const res = await apiClient.post<User>("/api/v1/users/me/photo", formData, {
        headers: {
            'Content-Type': 'multipart/form-data',
        }
    });
    return res.data;
}

export async function deleteAccount() {
    const res = await apiClient.delete("/api/v1/users/me");
    return res.data;
}
